export const RISK_REPORT_CHANGED = 'risk_report_changed';
export const RISK_SUMMARY_CHANGED = 'risk_summary_changed';
